import React from 'react';
import NodeNewsTeaser from './Teaser';
import NodeNewsFull from './Full';

const NodeNews = (props) => {
  const { viewMode } = props;
  switch (viewMode) {
    case 'teaser':
      return <NodeNewsTeaser {...props} />;

    default:
      return <NodeNewsFull {...props} />;
  }
};

export default NodeNews;
